import React from 'react';
import { Field, DatePicker, TimePicker, GroupField } from '@components';
import styled from 'styled-components';

const FieldDtExecucao = styled(Field)`
  margin-left: 0;
  flex: 2;
`;

export default function Mensal() {
  return (
    <GroupField>
      <FieldDtExecucao label='Período de execução' name='periodoDtExecucao'>
        <DatePicker.RangePicker format='DD/MM/YYYY' />
      </FieldDtExecucao>
      <Field label='Hora da execução' name='hrExecucao'>
        <TimePicker format='HH:mm:ss' />
      </Field>
    </GroupField>
  );
}
